
import { requestsListsData } from '../../components/common/config/tabsConfig'
import Tabs from '../../components/common/Tabs'
import { useSelector, useDispatch } from 'react-redux';
import { useFetchAllRequestorTabs } from '../../hooks/useFetchAllTabsData';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { setRequestorActiveTab } from '../../store/slices/Requestor/requestorTabSlice';
import { selectTimeOffRequestsCount } from '../../store/slices/Requestor/requestorTabCountSlice';
import { RootState } from '../../store/store';

const RequestsTabs = () => {
  // Fetch all 3 tabs data on initial load only
  useFetchAllRequestorTabs();

  const dispatch = useDispatch();
  const location = useLocation();
  
  // Get active tab from Redux store
  const activeTab = useSelector((state: RootState) => state.requestorTab.activeTab);
  
  // Check if navigation state contains activeTab (from vacation bid breadcrumbs)
  // If so, update Redux
  useEffect(() => {
    const stateTab = (location.state)?.activeTab;
    if (stateTab) {
      dispatch(setRequestorActiveTab(stateTab));
    }
  }, [location.state, dispatch]);

  // Get counts from Redux
  // Tab 1: Use dynamic count from requestorTabCount slice (switches between total and week-specific)
  // Tab 2 & 3: Use totalRecords directly
  const timeOffRequestsCount = useSelector(selectTimeOffRequestsCount);
  const historyCount = useSelector((state: RootState) => state.employeeInfo.timeOffHistory.totalRecords);
  const vacationBiddingCount = useSelector((state: RootState) => state.employeeInfo.vacationBidding.totalRecords);

  const dataLength = {
    1: timeOffRequestsCount,
    2: historyCount,
    3: vacationBiddingCount,
  };

  // Callback to update Redux when tab changes
  const handleSetActiveTab = (tabId: number) => {
    dispatch(setRequestorActiveTab(tabId));
  };

  return (
    <div className='mt-8 tablet:mt-20'>
      <Tabs
        tabs={requestsListsData}
        dataLength={dataLength}
        activeTab={activeTab}
        setActiveTab={handleSetActiveTab}
      />
    </div>
  )
}

export default RequestsTabs
